import useRole from "@nexys/hooks/useRole"

export function AdminUniversalRole(role = useRole()) {
  const normalizedRole = role?.toLowerCase?.()
  if (normalizedRole === 'admin' || normalizedRole === 'super admin' || normalizedRole === 'user') {
    return true
  }
  return false
}

export function AdminReadOnlyRole(role = useRole()) {
  if (role?.toLowerCase?.() === 'user') {
    return true
  }
  return false
}

export function AdminWriteRole(role = useRole()) {
  const normalizedRole = role?.toLowerCase?.()
  if (normalizedRole === 'admin' || normalizedRole === 'super admin') {
    return true
  }
  return false
}

export function AdminRole(role = useRole()) {
  if (role?.toLowerCase?.() === 'admin') {
    return true
  }
  return false
}

export function SuperAdminRole(role = useRole()) {
  if (role?.toLowerCase?.() === 'super admin') {
    return true
  }
  return false
}

export function MemberRole(role = useRole()) {
  if (role?.toLowerCase?.() === 'member') {
    return true
  }
  return false
}
